import { z } from "zod";

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "E-Mail ist erforderlich")
    .email("Ungültige E-Mail-Adresse")
    .max(255, "E-Mail ist zu lang"),
  password: z
    .string()
    .min(6, "Passwort muss mindestens 6 Zeichen lang sein")
    .max(100, "Passwort ist zu lang"),
});

export const signupSchema = z.object({
  firstName: z
    .string()
    .min(1, "Vorname ist erforderlich")
    .max(50, "Vorname ist zu lang")
    .regex(/^[a-zA-ZäöüÄÖÜß\s-]+$/, "Ungültiger Vorname"),
  lastName: z
    .string()
    .min(1, "Nachname ist erforderlich")
    .max(50, "Nachname ist zu lang")
    .regex(/^[a-zA-ZäöüÄÖÜß\s-]+$/, "Ungültiger Nachname"),
  email: z
    .string()
    .min(1, "E-Mail ist erforderlich")
    .email("Ungültige E-Mail-Adresse")
    .max(255, "E-Mail ist zu lang"),
  password: z
    .string()
    .min(8, "Passwort muss mindestens 8 Zeichen lang sein")
    .max(100, "Passwort ist zu lang"),
  acceptTerms: z
    .boolean()
    .refine((val) => val === true, {
      message: "Sie müssen die Nutzungsbedingungen und Datenschutzerklärung akzeptieren",
    }),
});

export const resetPasswordSchema = z.object({
  email: z
    .string()
    .min(1, "E-Mail ist erforderlich")
    .email("Ungültige E-Mail-Adresse")
    .max(255, "E-Mail ist zu lang"),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type SignupInput = z.infer<typeof signupSchema>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
